const styles = {
  root: {
    boxSizing: 'border-box',
    // paddingBottom: 100,
    height: '100vh',
  },
};

export default styles;
